<template>
  <div>
    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Register Levy</h5>
      </b-card-header>
      <b-card-body>
        <validation-observer
          ref="dataForm"
          #default="{ invalid }"
        >
          <b-form
            ref="form"
            @submit.stop.prevent="handleCreate"
          >
            <b-row>
              <b-col
                cols="12"
                md="4"
              >
                <b-row>
                  <b-col
                    cols="12"
                    md="12"
                    class="mb-md-0 mb-2"
                  >
                    <b-form-group
                      label-for="name"
                      label="Levy Name"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="name"
                        rules=""
                      >
                        <b-form-input
                          id="name"
                          v-model="levy.name"
                          name="name"
                          size="sm"
                          placeholder="Name"
                          autocomplete
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.name"
                          class="text-danger"
                        >{{ serverErrors.name[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                    md="7"
                    class="mb-md-0 mb-2"
                  >
                    <b-form-group
                      label-for="value"
                      label="Rate"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="value"
                        rules=""
                      >
                        <b-form-input
                          id="value"
                          v-model="levy.value"
                          name="value"
                          size="sm"
                          placeholder="Value"
                          type="number"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.value"
                          class="text-danger"
                        >{{ serverErrors.value[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="5"
                    class="mb-md-0 mb-2"
                  >
                    <b-form-group
                      label-for="currency_id"
                      label="Currency"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="currency_id"
                        rules=""
                      >
                        <b-form-select
                          id="currency_id"
                          v-model="levy.currency_id"
                          name="currency_id"
                          size="sm"
                        >
                          <b-form-select-option :value="null">
                            Select...
                          </b-form-select-option>
                          <b-form-select-option
                            v-for="currency in currencies"
                            :key="currency.id"
                            :value="currency.id"
                          >
                            {{ currency.abbreviation }}
                          </b-form-select-option>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.currency_id"
                          class="text-danger"
                        >{{ serverErrors.currency_id[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    cols="12"
                    md="7"
                    class="mb-md-0 mb-2"
                  >
                    <b-form-group
                      label-for="isPercentage"
                      label="Unit"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="isPercentage"
                        rules=""
                      >
                        <b-form-select
                          id="isPercentage"
                          v-model="levy.isPercentage"
                          name="isPercentage"
                          size="sm"
                        >
                          <b-form-select-option
                            v-for="unit in units"
                            :key="unit.isPercentage"
                            :value="unit.isPercentage"
                          >
                            {{ unit.description }}
                          </b-form-select-option>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.isPercentage"
                          class="text-danger"
                        >{{ serverErrors.isPercentage[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="5"
                    class="mb-md-0 mb-2"
                  >
                    <b-form-group
                      label-for="ofWeight"
                      label="Calculate"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="ofWeight"
                        rules=""
                      >
                        <b-form-select
                          id="ofWeight"
                          v-model="levy.ofWeight"
                          name="ofWeight"
                          size="sm"
                        >
                          <b-form-select-option
                            v-for="calculation in calculations"
                            :key="calculation.ofWeight"
                            :value="calculation.ofWeight"
                          >
                            {{ calculation.description }}
                          </b-form-select-option>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.ofWeight"
                          class="text-danger"
                        >{{ serverErrors.ofWeight[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    cols="12"
                    md="7"
                    class="mb-md-0 mb-2"
                  >
                    <b-form-group
                      label-for="paySociety"
                      label="Payable Entities"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="paySociety"
                        rules=""
                      >
                        <b-form-select
                          id="paySociety"
                          v-model="levy.paySociety"
                          name="paySociety"
                          size="sm"
                        >
                          <b-form-select-option
                            v-for="payable in payables"
                            :key="payable.paySociety"
                            :value="payable.paySociety"
                          >
                            {{ payable.description }}
                          </b-form-select-option>
                        </b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                        <small
                          v-if="serverErrors && serverErrors.paySociety"
                          class="text-danger"
                        >{{ serverErrors.paySociety[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col
                    cols="6"
                    class="mb-md-0 mb-2 pt-2"
                  >
                    <b-button
                      size="sm"
                      variant="primary"
                      :disabled="saving"
                      @click="submit()"
                    >
                      <b-spinner
                        v-if="saving"
                        small
                        class="mr-1"
                        label="Small Spinner"
                      />
                      <span v-if="!saving">Save</span>
                      <span v-if="saving">Saving...</span>
                    </b-button>
                  </b-col>

                  <b-col
                    cols="6"
                    class="mb-md-0 mb-2 pt-2 d-flex justify-content-end"
                  >
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="clear()"
                    >
                      Clear
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>

              <b-col
                cols="12"
                md="8"
              >
                <span style="font-size: 12px;">
                  Beneficiaries
                  <span v-if="levy.beneficiaries != undefined && levy.beneficiaries != null">({{ levy.beneficiaries.length.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0}) }})</span>
                  <span v-else>(0)</span>
                </span>
                <div style="position: relative; width:100%; height:24vh; inset: 20px 10px; border: 1px solid #eee;border-radius:2px;overflow-y: auto;">
                  <b-table
                    ref="beneficiaries"
                    striped
                    hover
                    small
                    class="position-relative"
                    :items="levy.beneficiaries"
                    responsive
                    :fields="beneficiariesColumns"
                    primary-key="id"
                    show-empty
                    empty-text="No beneficiary yet"
                  >
                    <template #cell(name)="data">
                      <span v-if="data.item.institution != null">{{ data.item.institution.name.toUpperCase() }}</span>
                      <span v-else>{{ data.item.society.name.toUpperCase() }}</span>
                    </template>
                    <template #cell(abbreviation)="data">
                      <span v-if="data.item.institution != null">{{ data.item.institution.abbreviation.toUpperCase() }}</span>
                      <span v-else>{{ data.item.society.code.toUpperCase() }}</span>
                    </template>
                    <template #cell(locations)="data">
                      <div id="component-breadcrumbs">
                        <b-breadcrumb
                          class="breadcrumb-pipes"
                          :items="data.item.institution != null? data.item.institution.locations.map(e => ({ text: e.name + ' ' + e.level.name, active: false })) : data.item.society.locations"
                        />
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
      <!-- {{ levy }} -->
    </b-card>
    <!-- ./Filters -->

    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search & Button -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
                size="sm"
              />
            </div>
          </b-col>
          <!-- ./Search & Button-->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        striped
        hover
        small
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(value)="data">
          <span v-if="data.item.isPercentage === 1">{{ data.item.value }}%</span>
          <span v-else>
            <span v-if="data.item.value !== null">{{ data.item.value.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 4,}) }}</span>
            <span v-else />
          </span>
        </template>

        <template #cell(isPercentage)="data">
          <span v-if="data.item.isPercentage === 1">Yes</span>
          <span v-else>No</span>
        </template>

        <template #cell(currency)="data">
          {{ data.item.currency.abbreviation }}
        </template>

        <template #cell(ofWeight)="data">
          <span v-if="data.item.ofWeight === 1">Sold KGs</span>
          <span v-else>Net Value</span>
        </template>

        <template #cell(paySociety)="data">
          <span v-if="data.item.paySociety === 0">Institutions</span>
          <span v-else>Societies</span>
        </template>

        <template #cell(beneficiaries)="data">
          {{ data.item.beneficiaries.length.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 3,}) }}
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="remove(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BForm, BFormGroup,
    BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
    BSpinner,
    BBreadcrumb,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import levysStoreModule from '@/views/cromis/levies/leviesStoreModule'
import uselevysList from '@/views/cromis/levies/useLevysList'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BTable,
        BPagination,
        BForm,
        BFormGroup,
        BButton,
        BFormSelect,
        BFormSelectOption,
        BFormInput,
        vSelect,
        BDropdown,
        BDropdownItem,
        BSpinner,
        BBreadcrumb,
        ValidationObserver,
        ValidationProvider,
    },
    directives: {},
    props: {},

    setup(props, context) {
        const serverErrors = ref(null)
        const saving = ref(false)
        const dataForm = ref(null)

        const currencies = ref([])

        const units = ref([
            { isPercentage: null, description: 'Select...' },
            { isPercentage: 1, description: 'Percent(%)' },
            { isPercentage: 0, description: 'Amount' },
        ])
        const calculations = ref([
            { ofWeight: null, description: 'Select...' },
            { ofWeight: 1, description: 'Sold KGs' },
            { ofWeight: 0, description: 'Net Value' },
        ])

        const payables = ref([
            { paySociety: null, description: 'Select...' },
            { paySociety: 0, description: 'Institutions' },
            { paySociety: 1, description: 'Societies' },
        ])

        const levy = ref({
            id: null,
            name: null,
            value: null,
            currency_id: null,
            isPercentage: null,
            ofWeight: null,
            paySociety: null,
            beneficiaries: [],
        })

        // Beneficiaries table columns
        const beneficiariesColumns = ref([
            {
                key: 'name', label: 'Institution', sortable: false, thStyle: { width: '30%' }, thClass: 'text-left', tdClass: 'text-left',
            },
            {
                key: 'abbreviation', label: 'Abbr/Code', sortable: false, thStyle: { width: '10%' }, thClass: 'text-left', tdClass: 'text-left',
            },
            {
                key: 'locations', label: 'Operates In', sortable: false, thStyle: { width: '60%' }, thClass: 'text-left', tdClass: 'text-left',
            },
        ])

        const CROMIS_STORE_MODULE_NAME = 'cromis-levy'

        // Register module
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, levysStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            await store.dispatch('cromis-levy/currencies')
                .then(response => {
                    currencies.value = response.data.currencies
                })
                .catch(error => {
                    console.log(error)
                })
        })

        const {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
        } = uselevysList()

        const clear = () => {
            levy.value = {
                id: null, name: null, abbreviation: null, rate: null, parameter: null,
            }
        }

        const invokeUpdateForm = item => {
            levy.value = {
                id: item.id,
                name: item.name,
                value: item.value,
                currency_id: item.currency.id,
                isPercentage: item.isPercentage,
                ofWeight: item.ofWeight,
                paySociety: item.paySociety,
                beneficiaries: item.beneficiaries,
            }
        }

        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = bvModalEvt => {
            serverErrors.value = null
            // Handle form submit
            if (levy.value.id === null || levy.value.id === 0) handleCreate()
            else handleUpdate(levy.value)
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-levy/create', levy.value)
                .then(response => {
                    refetch()
                    saving.value = false

                    levy.value = {
                        id: null,
                        name: null,
                        value: null,
                        currency_id: null,
                        isPercentage: null,
                        ofWeight: null,
                        paySociety: null,
                        beneficiaries: [],
                    }

                    context.root.$swal({
                        icon: 'success',
                        text: 'Levy was registered successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdate = async item => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-levy/update', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    levy.value = {
                        id: null,
                        name: null,
                        value: null,
                        currency_id: null,
                        isPercentage: null,
                        ofWeight: null,
                        paySociety: null,
                        beneficiaries: [],
                    }

                    context.root.$swal({
                        icon: 'success',
                        text: `Changes to levy ${response.data.name} has been saved successfully!`,
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            timer: 3000,
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const remove = async id => {
            await store.dispatch('cromis-levy/remove', id)
                .then(response => {
                    refetch()

                    context.root.$swal({
                        icon: 'info',
                        title: 'System Info',
                        text: 'Levy has been deleted successfully',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-info',
                        },
                        buttonsStyling: true,
                    })
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: true,
                    })
                })
        }

        return {
            dataForm,
            serverErrors,
            saving,
            levy,
            currencies,
            units,
            calculations,
            payables,

            fetch,
            columns,
            beneficiariesColumns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,

            submit,
            remove,
            clear,
            invokeUpdateForm,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
